import React from "react";
import { Route } from "react-router-dom";
import { Content } from "./Content";
import { NoAccess } from "./NoAccess"
import { useAccountType } from "../../../../hooks/useAccountType";

export function ContentRoute({ children, component, accessId, render, ...props }) {

  const accountType = useAccountType();
  const { hasPermission } = accountType;
  return (
    <Route {...props}>
      {routeProps => {


        if (typeof children === "function") {
          return <Content>{children(routeProps)}</Content>;
        }

        if (!routeProps.match) {
          return null;
        }

        if (accessId && !hasPermission(accessId)) {
          return <NoAccess />;
        }


        if (children) {
          return <Content>{children}</Content>;
        }

        if (component) {
          return (
            <Content>{React.createElement(component, routeProps)}</Content>
          );
        }

        if (render) {
          return <Content>{render(routeProps)}</Content>;
        }

        return null;
      }}
    </Route>
  );
}
